<template>
  <div class="tw:my-6" v-if="!isInitialLoading">
    <div class="tw:flex tw:gap-x-2">
      <FilterSelect
        id="home-page-rate-connect-performance-time-select"
        class="tw:w-1/2 tw:min-w-[120px] tw:md:w-[14%] tw:md:min-w-[200px]"
        :options="periodDatesOptions"
        @select="onSelectedPeriodChange"
        name="timeframe"
        :label="$t('rc_performance_timeframe')"
        :disabled="false"
        :value="selectedPeriodValue"
        :valueLabel="selectedPeriodValue?.label"
        :withTranslations="true"
      />
    </div>

    <div class="tw:grid tw:grid-cols-1 tw:lg:grid-cols-2 tw:gap-3 tw:my-3">
      <div v-for="item in periodSummary" :key="item.id" class="tw:basis-[calc(50%-0.5rem)]">
        <RateConnectPerformanceCard
          v-if="item.id !== 'clicks'"
          :noFilterData="statsData?.length === 0"
          :title="item.title"
          :hint="item.hint"
          :icon="item.icon"
          :id="item.id"
          :value="item.value"
          :progression="item.variation"
          :total="item.total"
          :hasRateConnect="hasRateConnect"
          :isRateConnectEligible="true"
        />
        <RateConnectClicksCard
          v-else
          :noFilterData="statsData?.length === 0"
          :title="item.title"
          :hint="item.hint"
          :icon="item.icon"
          :id="item.id"
          :value="item.value"
          :progression="item.variation"
          :total="item.total"
          :partnerDistribution="partnerDistribution"
          :hasRateConnect="hasRateConnect"
          :isRateConnectEligible="true"
        />
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import FilterSelect from '@/components/base/filters/FilterSelect.vue'
import RateConnectPerformanceCard from '@/components/homePage/performance/RateConnectPerformanceCard.vue'

import appAnalytics from '@/utils/tracking'

import { useRateConnectPerformance } from '@/components/rateConnect/performance/useRateConnectPerformance'
import { selectedAccommodationId } from '@/layouts/queries'
import RateConnectClicksCard from './RateConnectClicksCard.vue'

defineProps({
  periodSummary: Object,
  hasStatistics: Boolean,
  statsData: Array,
  isInitialLoading: Boolean,
  hasRateConnect: Boolean,
  partnerDistribution: Object,
})

const { selectedPeriod } = useRateConnectPerformance()

const periodDatesOptions = [
  {
    id: 0,
    name: 'trc_timeframe_last_14_days',
    value: 'last_14_days',
    label: 'trc_timeframe_last_14_days',
    default: false,
  },
  {
    id: 1,
    value: 'current_month',
    name: 'trc_timeframe_this_month',
    label: 'trc_timeframe_this_month',
    default: false,
  },
  { id: 2, value: 'last_30_days', name: 'last_30_days', label: 'last_30_days', default: true },
  { id: 3, value: 'last_3_months', name: 'last_3_months', label: 'last_3_months', default: false },
  { id: 4, value: 'last_6_months', name: 'last_6_months', label: 'last_6_months', default: false },
  { id: 5, value: 'last_12_months', name: 'last_12_months', label: 'last_12_months', default: false },
]

const selectedPeriodValue = computed(() => periodDatesOptions.find(item => item.value === selectedPeriod.value))

const onSelectedPeriodChange = newPeriod => {
  appAnalytics.track(appAnalytics.events.HOMEPAGE_RC_TIMEFRAME_CHANGED, {
    accommodationId: selectedAccommodationId.value,
    timeframe: newPeriod.option.value,
  })
  selectedPeriod.value = newPeriod.option.value
}
</script>
